import { Action, createAction } from '@reduxjs/toolkit';
import noop from 'lodash/noop';

import { AppDispatch } from 'bootstrap.store';

export const createPromiseAction = <
  TPayload,
  TResolve,
  TReject = unknown,
  TType extends string = string,
>(
  type: TType,
) =>
  createAction(
    type,
    (
      payload: TPayload,
      resolve: (data: TResolve) => void = noop,
      reject: (data: TReject) => void = noop,
    ) => ({
      payload,
      meta: { resolve, reject },
    }),
  );

export function bindRtkActionToPromise<TPayload, TResolveValue, TRejectValue>(
  dispatch: AppDispatch,
  actionCreator: (
    payload: TPayload,
    resolve: (data: TResolveValue) => void,
    reject: (error: TRejectValue) => void,
  ) => Action,
) {
  return (payload: TPayload) => {
    return new Promise<TResolveValue>((resolve, reject) =>
      dispatch(actionCreator(payload, resolve, reject)),
    );
  };
}
